import { apiFetch } from "./config.js";
/**
 * List every commercial agreement (PPA, fuel supply agreement, etc) the
 * company is party to, each with a real rollup of its own still-open
 * claim candidates. Wrap in `useQuery` with a queryKey of
 * `["company-agreements"]`.
 */
export async function listCompanyAgreements(signal) {
    return apiFetch("/company-agreements", { method: "GET", signal });
}
/** Deep portfolio view for one contract: ledger, gaps, claims, and ingestion status. */
export async function getPortfolioAgreementDetail(agreementId, signal) {
    return apiFetch(`/company-agreements/${encodeURIComponent(agreementId)}/portfolio-detail`, { method: "GET", signal });
}
